import React from 'react'
import ReactDOM from 'react-dom'
import isNode from 'detect-node'
import { getStack, subscribe, hideModal } from './store'

// Mounted once (see layouts/GlobalLayout/WhiteLabelRoot.js). Portals whatever
// showModal() last pushed straight to document.body, so it renders above
// everything regardless of where in the tree showModal was called from,
// while staying inside the app's React tree (redux/theme context intact).
// Renders the whole stack (not just the top) so a modal opened on top of
// another (e.g. DatePickerModal over DateTimeModal) doesn't unmount and lose
// the one underneath — hideModal() always closes just the top entry.
export default class DynamicModal extends React.PureComponent {
  state = { stack: getStack() }

  componentDidMount() {
    this.unsubscribe = subscribe((stack) => this.setState({ stack }))
    // A page mounts before this does, so a modal it shows on mount (e.g.
    // VendorView's catering-only notice) lands before the subscribe.
    this.setState({ stack: getStack() })
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    this.unsubscribe()
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  // Escape closes the top modal only, the same as clicking outside it. One
  // listener here rather than one per modal, so a stacked pair (DatePickerModal
  // over DateTimeModal) doesn't both close on a single press.
  handleKeyDown = (e) => {
    if (e.key !== 'Escape' || this.state.stack.length === 0) return
    hideModal()
  }

  render() {
    if (isNode || this.state.stack.length === 0) return null

    return ReactDOM.createPortal(
      this.state.stack.map(({ Component, props }, index) => (
        <Component key={index} {...props} isOpen onRequestClose={hideModal} />
      )),
      document.body,
    )
  }
}
